import { SearchSortBy } from "../../../features/algolia/api/types/search"

export interface SortByItem {
  id: string
  key: SearchSortBy
  value: string
  label: string
  default: boolean
}

export const sortBy: SortByItem[] = [
  {
    key: "weight",
    id: "modus_products",
    value: "modus_products",
    label: "Consigliati",
    default: true,
  },
  {
    key: "priceAsc",
    id: "modus_products_price_asc",
    value: "modus_products_price_asc",
    label: "Prezzo più basso",
    default: false,
  },
  {
    key: "priceDesc",
    id: "modus_products_price_desc",
    value: "modus_products_price_desc",
    label: "Prezzo più alto",
    default: false,
  },
  {
    key: "az",
    id: "modus_products_price_az",
    value: "modus_products_price_az",
    label: "Dalla A alla Z",
    default: false,
  },
]

const getDefaultSortItem = () => sortBy.find((x) => x.default)

export const getDefaultSortBy = () => getDefaultSortItem()?.key

export const getDefaultSortIndex = () => getDefaultSortItem()?.id

export const getSortIndex = (value: SearchSortBy) =>
  sortBy.find((x) => x.key === value)?.id

export const getSortKey = (indexName: string): SearchSortBy =>
  sortBy.find((x) => x.id === indexName)?.key as SearchSortBy
